<template>
	<router-view></router-view>
</template>

<script>
import store from '../../../store';

export default {
	async beforeRouteEnter(to, from, next) {
		store.dispatch('trade/setCashBalance');

		next();
	},
};
</script>